import BreadCrumb from "../../../../components/breadcrumb";
import { sliders } from "../../../../data/constants";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { SliderData } from "../../../../components/tables/sliders-tables/slider";
import { useEffect, useState } from "react";
import { Slider } from "@/src/data/types";
import { getAllSliders } from "../../../../API/Slider/sliderService";

const breadcrumbItems = [{ title: "Slider", link: "/admin-dashboard/sliders" }];
export default function Sliders() {
  const [sliders, setSliders] = useState<Slider[]>([]);
  const fetchData = async () => {
    const response = await getAllSliders();
    setSliders(response?.sliders);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <SliderData data={sliders} />
        </div>
      </div>
    </>
  );
}
